import { clsx } from 'clsx';
import { FC, ReactNode } from 'react';

import { MICROCOPY } from '@/data/microcopy/microcopyDictionary';
import { getMicrocopy } from '@/stores/microcopyStore';

import styles from './CheckoutFooter.module.scss';

const TERMS_CONDITIONS_URL = '/terms-and-conditions';
const POLICY_URL = '/privacy-policy';
const COLLECTION_NOTICE_URL = '/privacy-collection-notice';

interface Option {
  url: string;
  label: ReactNode;
}

interface CheckoutFooterProps {
  className?: string;
  options?: Option[];
}

export const CheckoutFooter: FC<CheckoutFooterProps> = ({ className, options }) => {
  const defaultOptions = [
    {
      url: TERMS_CONDITIONS_URL,
      label: getMicrocopy(MICROCOPY.CHECKOUT_FOOTER_LINK_1),
    },
    {
      url: POLICY_URL,
      label: getMicrocopy(MICROCOPY.CHECKOUT_FOOTER_LINK_2),
    },
    {
      url: COLLECTION_NOTICE_URL,
      label: getMicrocopy(MICROCOPY.CHECKOUT_FOOTER_LINK_3),
    },
  ];

  return (
    <footer className={clsx(styles.root, className)}>
      <div className={styles.copyright}>
        {getMicrocopy(MICROCOPY.GENERAL_FOOTER_COPYRIGHT, false, {
          year: `${new Date().getFullYear()}`,
        })}
      </div>
      <ul className={styles.footerLinks}>
        {(options || defaultOptions).map((option) => (
          <li className={styles.footerLinkItem} key={option.label?.toString()}>
            <a href={option.url} target="_blank" rel="noopener noreferrer" className={styles.footerLink}>
              {option.label}
            </a>
          </li>
        ))}
      </ul>
    </footer>
  );
};
